function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#E6AC39",
  d: "M19.372 4.632a.628.628 0 01.054 1.253l-.054.003h-4.688a.628.628 0 01-.054-1.254l.054-.002h4.688zm0-2.455a.628.628 0 01.054 1.254l-.054.002h-6.024a.628.628 0 01-.054-1.254l.054-.002h6.024zm0 4.905a.628.628 0 01.054 1.254l-.054.003h-4.688a.628.628 0 01-.054-1.254l.054-.003h4.688zm0 2.455a.628.628 0 01.054 1.254l-.054.002h-6.024a.628.628 0 01-.054-1.254l.054-.002h6.024zM10.492 0C4.742 0 0 2.816 0 6.483c0 3.63 4.643 6.432 10.322 6.486l.167.001a.628.628 0 00.58-.382A15.563 15.563 0 0011.157.591L11.07.386a.628.628 0 00-.58-.386zm-.42 1.262a14.304 14.304 0 01.074 10.254l-.074.192-.06-.001a15.582 15.582 0 01-1.865-.166l-.297-.048c-3.84-.66-6.594-2.712-6.594-5.01 0-2.681 3.755-5.023 8.596-5.214l.22-.007z"
});

function SvgHeadlightsOnToggleHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 13"
  }, props), _ref);
}

export default SvgHeadlightsOnToggleHover;